import React from 'react';
import JSXCode from '../../Components/JSXCode';
import NewDesign from 'components/NewDesign';

import ExampleFullTableInfiniteScrollQueryPage from 'pages/Document/Components/ExampleFullTableInfiniteScrollQueryPage';

const TabFullPageWithTableInfiniteScrollGuide = (props) => {
  //! State

  //! Function

  //! Render

  return (
    <div className='component:TabFullPageWithTableInfiniteScrollGuide'>
      <NewDesign.Typography className='tw-text-2xl tw-mb-5' component='p'>
        Full Example For Table + Infinite scroll
      </NewDesign.Typography>

      <div className='tw-my-2'>
        <ExampleFullTableInfiniteScrollQueryPage />
      </div>

      <JSXCode
        code={`import React, { Fragment, useMemo } from 'react';
import DataGrid from 'components/DataGrid';
import DataGridColumnHeader from 'components/DataGridColumnHeader';
import FormikFields from 'components/FormikFields';
import SearchAndFilters from 'components/SearchAndFilters';
import useFilters from 'hooks/useFilters';
import { useInfiniteQuery } from '@tanstack/react-query';
import services from 'services';
import { flatten, isEmpty } from 'lodash';
import querystring from 'query-string';

const ExampleFullTableInfiniteScrollQueryPage = () => {
  const { filters, sorting, handleSorting, handleSearch, resetFilterToInitial } = useFilters({
    page: 0,
    pageSize: 20,
    name: '',

    sortField: '',
    sortDirection: '',
  });

  const {
    data: response,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ['example-infinite-scroll', filters],
    queryFn: async ({ pageParam }) => {
      const body = {
        _start: pageParam * filters.pageSize,
        _limit: filters.pageSize,
      };
      const response = await services.get(
        'https://jsonplaceholder.typicode.com/todos?' + querystring.stringify(body)
      );
      return response?.data;
    },
    initialPageParam: filters.page,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage?.data?.length <= 0 || lastPage?.data?.length < filters.pageSize) {
        return undefined;
      }

      return lastPageParam + 1;
    },
    getPreviousPageParam: (firstPage, allPages, firstPageParam) => {
      if (firstPageParam <= filters.page) {
        return undefined;
      }
      return firstPageParam - 1;
    },
  });

  const data = useMemo(() => {
    if (isEmpty(response)) {
      return [];
    }

    return flatten(response.pages);
  }, [response]);

  const columns = useMemo(() => {
    return [
      {
        header: ({ column }) => <DataGridColumnHeader column={column} title={'ID'} />,
        accessorKey: 'id',
      },
      {
        header: 'Title',
        accessorKey: 'title',
      },
    ];
  }, []);

  return (
    <div className='component:ExampleFullTableInfiniteScrollQueryPage'>
      <code>{JSON.stringify({ filters })}</code>
      <SearchAndFilters
        initialValues={filters}
        classNameContainer='tw-mb-3'
        classNameButtonContainer='align-self-end'
        renderFilter={({ propsFormik }) => {
          return (
            <Fragment>
              <FormikFields.Input name='name' label='Name' placeholder='Search by name...' />
            </Fragment>
          );
        }}
        onResetSearch={({ resetForm }) =>
          () => {
            resetForm();
            //* force reset filters and refetch
            resetFilterToInitial({ timestamp: new Date().getTime() });
          }}
        onSubmitSearch={(values) => {
          handleSearch(values);
        }}
      />

      <DataGrid
        dataSource={{
          isFetching: isLoading,
          data: data || [],
          fetchNextPage: fetchNextPage,
          hasMore: hasNextPage,
          loadingMore: isFetchingNextPage,
        }}
        columns={columns}
        manualControl={{
          sorting: sorting,
          setSorting: handleSorting,
        }}
        hideColumnView
        tableClassName='tw-h-[calc(100vh-300px)]'
      />
    </div>
  );
};

export default ExampleFullTableInfiniteScrollQueryPage;`}
      />
    </div>
  );
};

export default TabFullPageWithTableInfiniteScrollGuide;
